import { createFileRoute } from "@tanstack/react-router";
import { MemoryBrowsePage } from "@/components/memory/memory-browse-page";
import { useWorkspaceRoot } from "@/lib/api";

/**
 * The Data hub's Schema tab (`/data`): the type map, plus the tab strip when
 * workspace views exist. Each view lives at its own path
 * (`/data/-/views/<key>`), so this route owns its query outright: just
 * `create_type`, the new-type subpage.
 */
export const Route = createFileRoute("/$owner/data/")({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
	},
	validateSearch: (search: Record<string, unknown>): { create_type?: string } => ({
		// `stringifyRouterSearch` JSON-parses primitive values, so `?create_type=true`
		// round-trips as boolean `true` — normalize to the string the UI reads.
		create_type:
			search.create_type === true || search.create_type === "true"
				? "true"
				: undefined,
	}),
	component: DataPage,
});

function DataPage() {
	const { owner } = Route.useParams();
	const search = Route.useSearch();
	return (
		<MemoryBrowsePage
			ownerSlug={owner}
			create={false}
			createType={search.create_type === "true"}
		/>
	);
}
